import { EditorState, Transaction } from 'prosemirror-state';
import { Step } from 'prosemirror-transform';

/**
 * Creates a transaction from the given state and adds the steps to it.
 * @param editorState The state of the editor.
 * @param steps The steps to apply to the transaction.
 * @returns The transaction with the steps added to it.
 */
export function createTransactionForState(editorState: EditorState, steps: Step[]): Transaction {
  const tr = editorState.tr;

  for (const step of steps) {
    tr.step(step);
  }

  return tr;
}
